<template>
  <div class="CL_wrapper">
    <img src="@/assets/empty.webp" width="800px" />
  </div>
</template>

<script>
export default {};
</script>


<style lang="scss" scoped>
.CL_wrapper {
  width: 1200px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>